/**
 * Safety guards for permission overrides.
 *
 * Prevents dangerous permission configurations that could
 * lock out admins or break critical workflows.
 */

import type { Role } from "./types";

/**
 * Roles whose permissions cannot be overridden.
 * Admin always has full access — this is a safety invariant.
 */
export const NON_OVERRIDABLE_ROLES: ReadonlySet<Role> = new Set([
  "admin",
] as const);

/**
 * Roles that can be customized in the permissions management UI.
 */
export const CUSTOMIZABLE_ROLES: Role[] = [
  "supervising_pharmacist",
  "pharmacist",
  "pharmacy_intern",
  "technician",
  "auditor",
];
